import { api} from "../config";


export const apiCallsParking = {
  Actions: {
    GetDevices: async (filters) => {
      try {
        const response = await api.get("ParkingProfile", {
          params : {
            Search : filters.search,
            Free: filters.deviceStates.open,
            Οccupied : filters.deviceStates.close,
            SuccessConnection : filters.deviceStates.join,
            HasError : filters.deviceStates.error,
          }
        });
        if (response.data) {
          return response.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    GetStatsForGraph: async (filters) => {
      try {
        const response = await api.get("ParkingProfile/graph-stats", {
          params : {
            Search : filters.search,
            Free: filters.deviceStates.free,
            Οccupied : filters.deviceStates.close,
            SuccessConnection : filters.deviceStates.join,
            HasError : filters.deviceStates.error,
          }
        });
        if (response.data) {
          return response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    GetDeviceStatuses: async () => {
      try {
        const response = await api.get("ParkingProfile/device-statuses");
        return response.data?.data ?? [];
      } catch (error) {
        console.error("API Error", error.response?.data || error.message);
        return [];
      }
    },

    SiteInfo: async (deviceId) => {
      try {
          const response = await api.get(`ParkingProfile/site-info/${deviceId}`);

          return response.data.data;
      } catch (error) {
          console.error("API Error", error.response?.data || error.message);
      }
    },

    DeviceInfo: async (deviceId) => {
      try {
          const response = await api.get(`ParkingProfile/device-info/${deviceId}`);

          return response.data.data;
      } catch (error) {
          console.error("API Error", error.response?.data || error.message);
      }
    },
  },
};
